'use client';

import useTabularFileEntries from '@/components/BranchFileVersionSelect/useTabularFileEntries';
import { IRepository } from '@/types';
import { ITabularFileResponse } from '@/lib/tabularFileApi';
import { humanFileSize } from '@/lib/format';
import * as Styled from './styled';
import Link from 'next/link';
import * as Icon from '@/ui/Icon';

const TabularFilePicker: React.FC<{ repository: IRepository; responseData?: ITabularFileResponse }> = ({
  repository,
  responseData,
}) => {
  const { status, isLoading, entries, error } = useTabularFileEntries({
    repository,
    initialData: responseData,
  });
  if (status === 'error') {
    return <div>{error?.title}</div>;
  }
  if (isLoading) {
    return <div>Loading...</div>;
  }
  const baseEvalPath = `/${repository.namespace}/${repository.name}/evaluations`;
  return (
    <Styled.TabularFilePicker>
      <table>
        <tbody>
          {entries
            .sort((a, b) => a.filename.localeCompare(b.filename))
            .map((entry) => (
              <tr key={entry.filename}>
                <td width="90%">{entry.filename}</td>
                <td className="right">{humanFileSize(entry.size)}</td>
                <td className="right">
                  <Link href={`${baseEvalPath}/new?path=${entry.filename}`} className="link-underline">
                    Evaluate this file <Icon.ArrowRight />
                  </Link>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </Styled.TabularFilePicker>
  );
};

export default TabularFilePicker;
